import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import scrollToComponent from 'react-scroll-to-component';

import * as faq from '../../../constants/faq';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class Faq extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedSubject: null,
      selectedQuestion: null,
      searchText: '',
    }
  }

  componentWillMount() {
    document.title = 'Diamonds Direct - Frequently Asked Questions';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  userNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  openContact() {
    this.props.commonOpenContact();
  }

  getAutocompleteQuestions() {
    
    let matchedQuestions = [];
    let maxLength = 10;
    let matchCount = 0;
    let searchTerm = this.state.searchText.toLowerCase();
    let backupTerm = null;

    switch(searchTerm) {
      case 'returns':
        backupTerm = 'return';
        break;
      case 'payments':
        backupTerm = 'payment';
        break;
      case 'warranty':
        backupTerm = 'warranties';
        break;
      case 'warranties':
        backupTerm = 'warranty';
        break;
    }

    for(let i = 0; i < faq.QUESTIONS.length; i++) {
      
      let index = faq.QUESTIONS[i].title.toLowerCase().indexOf(searchTerm);
      if(index >= 0) {

        let questionObj = faq.QUESTIONS[i];
        questionObj['resultIndex'] = index;
        questionObj['resultTerm'] = searchTerm;

        matchedQuestions.push(questionObj);
        matchCount++;

        continue;
      }

      if(backupTerm) {
        index = faq.QUESTIONS[i].title.toLowerCase().indexOf(backupTerm);
        if(index >= 0) {

          let questionObj = faq.QUESTIONS[i];
          questionObj['resultIndex'] = index;
          questionObj['resultTerm'] = backupTerm;

          matchedQuestions.push(questionObj);
          matchCount++;
        }
      }

      if(matchedQuestions.length >= 8) {
        break;
      }
    }

    return matchedQuestions;
  }

  changeSearchText(evt) {
    this.setState({ searchText: evt.target.value });
  }

  getSectionName(subject) {
    switch(subject) {
      case 'ordering':
        return 'Shopping, Shipping, and Special Orders';
      case 'payment':
        return 'Payment Method and Financing';
      case 'warranty':
        return 'Warranties and Repair Policy';
      case 'upgrade':
        return 'Upgrades and Trade-Ins';
      case 'returns':
        return 'Return Policy';
      case 'privacy':
        return 'Privacy and Security';
      default:
        return 'Frequently Asked Questions';
    }
  }

  toggleQuestion(question) {
    if(this.state.selectedQuestion === null || (this.state.selectedQuestion && this.state.selectedQuestion.title != question.title)) {
      this.setState({ selectedQuestion: question });
      console.log('question');
    } else {
      this.setState({ selectedQuestion: null });
    }
  }

  toggleSubject(subject) {
    if(this.state.selectedSubject !== subject) {
      this.setState({ selectedSubject: subject });
      this.scrollToBlock(subject);
    } else {
      this.setState({ selectedSubject: null, selectedQuestion: null });
    }
  }

  closeSubject() {
    this.setState({ selectedSubject: null, selectedQuestion: null });
  }

  getQuestionClass(question) {
    if(this.state.selectedQuestion !== null && this.state.selectedQuestion.title == question.title) {
      return 'questionEntry open';
    } else {
      return 'questionEntry';
    }
  }

  scrollToBlock(subject) {

    let section = null;
    switch(subject) {
      case 'ordering':
        section = this.orderingBlock;
        break;
      case 'payment':
        section = this.paymentBlock;
        break;
      case 'warranty':
        section = this.warrantyBlock;
        break;
      case 'upgrade':
        section = this.upgradeBlock;
        break;
      case 'returns':
        section = this.returnBlock;
        break;
      case 'privacy':
        section = this.privacyBlock;
        break;
    }

    if(section) {
      scrollToComponent(section, {
        offset: 0, 
        align: 'top', 
        duration: 800, 
        ease: 'inOutCube',
      });
    }
  }

  renderQuestionAccordian(subject) {
    return <div className={this.state.selectedSubject === subject ? 'questionAccordian open' : 'questionAccordian'}>
      <div className='accordianWrapper'>
        <div className='accordianClose' onClick={::this.closeSubject}>
          <img src='https://ddw2.diamondsdirect.com/img/faq/x.svg' />
        </div>
        <div className='accordianTitle'>
          {this.getSectionName(subject)}
        </div>
        <div className='accordianBr'>
          <img src='https://ddw2.diamondsdirect.com/img/faq/logo_line.svg' />
        </div>
        {faq.QUESTIONS.map((question, i) => {

          if(subject !== question.subject) {
            return null;
          }

          return <div className={this.getQuestionClass(question)} key={i} onClick={() => this.toggleQuestion(question)}>
            <div className='questionTitle'>
              <div className='titleArrow'></div>
              {question.title}
            </div>
            <div className='questionBody'>
              <div className='bodyWrapper' dangerouslySetInnerHTML={{__html: question.body}} />
            </div>
          </div>;
        })}
      </div>
    </div>;
  }

  autosuggestClass() {
    return this.state.searchText.length >= 2 ? 'searchSuggestions open' : 'searchSuggestions';
  }

  openSearchQuestion(question) {
    this.setState({
      selectedSubject: question.subject,
      selectedQuestion: question,
      searchText: '',
    });
    this.scrollToBlock(question.subject);
  }

  formattedTitle(question) {

    let titleCopy = question.title;
    let formattedTitle = titleCopy.slice(0, question.resultIndex) + '<span class="searchEm">' + titleCopy.slice(question.resultIndex, question.resultIndex + question.resultTerm.length) + '</span>' + titleCopy.slice(question.resultIndex + question.resultTerm.length);

    return formattedTitle;
  }

  getBlockClass(subject) {
    let classSubject = subject;
    if(subject == 'returns') {
      classSubject = 'return';
    }

    if(this.state.selectedSubject == subject) {
      return 'faqSubjectBlock open ' + classSubject + 'Block';
    } else {
      return 'faqSubjectBlock ' + classSubject + 'Block';
    }
  }

  render() {

    let autocompleteQuestions = this.getAutocompleteQuestions();

    return <div className='Faq'>
      <div className='faqHeader'>
        <div className='headerInnerWrapper'>
          <div className='faqIcon'>Faq</div>
          <div className='faqHeaderText'>
            For orders placed at one of our locations please <span className='headerLink' onClick={::this.openContact}>contact a store nearest you</span>. For orders placed online please reply to your order confirmation email or email us at <a href='mailto:online@diamondsdirect.com'>online@diamondsdirect.com</a>.
          </div>
        </div>
      </div>
      <div className='faqSearch'>
        <div className='searchTitleWrapper'>We're here to help!</div>
        <div className='searchInputWrapper'>
          <input type='text' placeholder='Search FAQ' value={this.state.searchText} onChange={::this.changeSearchText} />
          <div className='searchIcon'>
            <i className={'fas fa-search'}></i>
          </div>
          <div className={this.autosuggestClass()}>
            <div className='searchInnerWrapper'>
              {autocompleteQuestions.length > 0 ?
                <div className='suggestionsWrapper'>
                  {autocompleteQuestions.map((question, i) => {
                    return <div className='suggestionEntry' onClick={() => this.openSearchQuestion(question)} key={i} dangerouslySetInnerHTML={{__html: this.formattedTitle(question)}} />;
                  })}
                </div> :
                null
              }
              <div className='suggestionContact'>
                No Match? <span className='contactLink' onClick={::this.openContact}>Contact Us!</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='faqBlocks'>
        <div className={this.getBlockClass('ordering')} onClick={() => this.toggleSubject('ordering')} ref={(div) => { this.orderingBlock = div; }}>
          <div className='blockIcon'></div>
          <div className='blockTitle'>Shopping, Shipping, and Special Orders</div>
          <div className='blockPrompt'>Click Here ></div>
        </div>
        <div className='mobileAccordian'>{this.renderQuestionAccordian('ordering')}</div>
        

        <div className={this.getBlockClass('warranty')} onClick={() => this.toggleSubject('warranty')} ref={(div) => { this.warrantyBlock = div; }}>
          <div className='blockIcon'></div>
          <div className='blockTitle'>Warranties and Repair Policy</div>
          <div className='blockPrompt'>Click Here ></div>
        </div>
        <div className='tabletAccordian'>{this.renderQuestionAccordian('ordering')}</div>
        <div className='tabletAccordian'>{this.renderQuestionAccordian('warranty')}</div>

        <div className='mobileAccordian'>{this.renderQuestionAccordian('warranty')}</div>

        
        <div className={this.getBlockClass('upgrade')} onClick={() => this.toggleSubject('upgrade')} ref={(div) => { this.upgradeBlock = div; }}>
          <div className='blockIcon'></div>
          <div className='blockTitle'>Upgrades and Trade-Ins</div>
          <div className='blockPrompt'>Click Here ></div>
        </div>
        <div className='desktopAccordian'>{this.renderQuestionAccordian('ordering')}</div>
        <div className='desktopAccordian'>{this.renderQuestionAccordian('warranty')}</div>
        <div className='desktopAccordian'>{this.renderQuestionAccordian('upgrade')}</div>

        <div className='mobileAccordian'>{this.renderQuestionAccordian('upgrade')}</div>
        

        <div className={this.getBlockClass('payment')} onClick={() => this.toggleSubject('payment')} ref={(div) => { this.paymentBlock = div; }}>
          <div className='blockIcon'></div>
          <div className='blockTitle'>Payment Method and Financing</div>
          <div className='blockPrompt'>Click Here ></div>
        </div>
        <div className='tabletAccordian'>{this.renderQuestionAccordian('upgrade')}</div>
        <div className='tabletAccordian'>{this.renderQuestionAccordian('payment')}</div>

        <div className='mobileAccordian'>{this.renderQuestionAccordian('payment')}</div>
        

        <div className={this.getBlockClass('returns')} onClick={() => this.toggleSubject('returns')} ref={(div) => { this.returnBlock = div; }}>
          <div className='blockIcon'></div>
          <div className='blockTitle'>Return Policy</div>
          <div className='blockPrompt'>Click Here ></div>
        </div>
        <div className='mobileAccordian'>{this.renderQuestionAccordian('returns')}</div>
        

        <div className={this.getBlockClass('privacy')} onClick={() => this.toggleSubject('privacy')} ref={(div) => { this.privacyBlock = div; }}>
          <div className='blockIcon'></div>
          <div className='blockTitle'>Privacy and Security</div>
          <div className='blockPrompt'>Click Here ></div>
        </div>
        <div className='desktopAccordian'>{this.renderQuestionAccordian('payment')}</div>
        <div className='desktopAccordian'>{this.renderQuestionAccordian('returns')}</div>
        <div className='desktopAccordian'>{this.renderQuestionAccordian('privacy')}</div>

        <div className='tabletAccordian'>{this.renderQuestionAccordian('returns')}</div>
        <div className='tabletAccordian'>{this.renderQuestionAccordian('privacy')}</div>

        <div className='mobileAccordian'>{this.renderQuestionAccordian('privacy')}</div>


      </div>
    </div>;
  }
}
export default Faq;

function mapStateToProps(state) {
  return {
    common: state.common,
    header: state.header,
  };
}

export const FaqContainer = connect(
  mapStateToProps,
  allActionCreators
)(Faq);


// WEBPACK FOOTER //
// ./src/components/views/faq/Faq.jsx